import { render, staticRenderFns } from "./rejectedIncident.vue?vue&type=template&id=2fa2fae6&scoped=true"
import script from "./rejectedIncident.vue?vue&type=script&lang=js"
export * from "./rejectedIncident.vue?vue&type=script&lang=js"
import style0 from "./rejectedIncident.vue?vue&type=style&index=0&id=2fa2fae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa2fae6",
  null
  
)

export default component.exports